import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4zww6v8k83: FaireBrandEntity = {
  token: "b_4zww6v8k83",
  type: "brand",
  name: "Ikeuchi",
  avatarUrl:
    "https://cdn.faire.com/fastly/313479b876d36599a7061d9a99af4771ccb5982547336cb666598febc838cc7f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d5ea2269ca92cd12924eb3d7315c2ead26b334b0384feda2cef16dc6cd02f8dc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/313479b876d36599a7061d9a99af4771ccb5982547336cb666598febc838cc7f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d5ea2269ca92cd12924eb3d7315c2ead26b334b0384feda2cef16dc6cd02f8dc.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description:
    "Casey Ikeuchi Felton is a James Beard nominated chef whose culinary philosophy is rooted in both the kitchen and the garden. Raised in Los Angeles, her tastebuds were shaped by the city's immigrant cultures, sparking a lifelong love for bold, layered flavors that tell a story. Her garden-inspired finishing salts, a sweet toasted finishing blend, and Japanese inspired Bonito Crunch-an umami-forward chili crisp — is built around one behavior: finishing a dish just before serving.  This habit has been used by professional chefs for years. ",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:49.519Z",
    importedBy: "entity-db-cli",
  },
};
